import cx from 'classnames'
import PropTypes from 'prop-types'

import {useSearchTags} from '@adv-mt/mt-search-tags'

const BASE_CLASS = 'mt-NetFilterTagsCard'

const FilterTagsCard = ({filters, isWide = false, children}) => {
  const tags = useSearchTags({search: filters})

  if (!tags.length) return children

  return (
    <div className={BASE_CLASS}>
      <div className={`${BASE_CLASS}-tags`}>{tags.map(({label}) => label).join(' · ')}</div>
      <div
        className={cx(`${BASE_CLASS}-action`, {
          [`${BASE_CLASS}-action--wide`]: isWide
        })}
      >
        {children}
      </div>
    </div>
  )
}

FilterTagsCard.displayName = 'FilterTagsCard'

FilterTagsCard.propTypes = {
  filters: PropTypes.object,
  isWide: PropTypes.bool,
  children: PropTypes.node.isRequired
}

export default FilterTagsCard
